import { getWidgetStores } from '@/entities/widget';
import type { DetailHeaderProps } from './DetailHeader.types';

export function DetailHeader(props: DetailHeaderProps) {
  const { item } = props;
  // ChatMarkdownRenderer via the entities/widget binding seam.
  const { ChatMarkdownRenderer } = getWidgetStores().chatStore;

  return (
    <div data-testid="social-brief-detail-header" className="flex flex-col gap-6">
      <p className="text-heading-xl text-foreground">{item.overview.opportunityTitle}</p>

      <div className="text-body-lg text-foreground">
        <ChatMarkdownRenderer
          content={item.overview.opportunityDescription}
          disableAnimation
          inline
        />
      </div>
    </div>
  );
}
